import {withForm} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'
import {getParameterDefaultValuesNew} from '@/modules/patients/functions'
import {ParameterSchemaNew} from '@/modules/patients/schemas'
import {useGetInfiniteDrugCatalogItems} from '@/modules/drug-catalog/substances/api/use-get-infinite-drug-catalog-items'

export const ActiveSubstanceSelect = withForm({
  defaultValues: getParameterDefaultValuesNew(false, undefined, false) as ParameterSchemaNew,
  props: {} as {hasMultiple?: boolean; index: number; disabled?: boolean},
  render: function Render({form, hasMultiple, index, disabled}) {
    const {t} = useTranslate('common')
    const activeSubstances = useGetInfiniteDrugCatalogItems()

    return (
      <form.AppField name={`medicine[${index}].activeSubstanceId`} mode="value">
        {field => (
          <field.InfiniteCombobox
            size="sm"
            label={`${t('drug')} ${hasMultiple ? index + 1 : ''}`}
            placeholder={t('type_to_search')}
            {...activeSubstances}
            disabled={disabled}
          />
        )}
      </form.AppField>
    )
  },
})
